import { useMutation, useQueryClient } from "@tanstack/react-query";

import { ErrorNotification } from "../components/notification/ErrorNotification.tsx";
import { SuccessNotification } from "../components/notification/SuccessNotification.tsx";
import { ReactQueryKeys } from "../services/ReactQueryKeys";
import { useSenderService } from "../services/useSenderService.ts";

export function useSenderMutation() {
  const { removeSender, updateSendingMode, createSender, refreshSenders } = useSenderService();
  const queryClient = useQueryClient();
  const removeSenderMutation = useMutation({
    mutationFn: (email: string) => removeSender(email),
    onError: () => {
      ErrorNotification("A problem occurred while deleting the sender.");
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [ReactQueryKeys.SENDERS] });
      SuccessNotification("Sender deleted.");
    }
  });

  const switchLogModeSenderMutation = useMutation({
    mutationFn: (id: number) => updateSendingMode(id),
    onError: () => {
      ErrorNotification("A problem occurred while switching the sender to logging mode.");
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [ReactQueryKeys.SENDERS] });
    }
  });

  const saveSenderMutation = useMutation({
    mutationFn: (email: string) => createSender(email),
    onError: () => {
      ErrorNotification("A problem occurred while creating sender.");
    },
    onSuccess: () => {
      SuccessNotification("Sender successfully created.");
      queryClient.invalidateQueries({ queryKey: [ReactQueryKeys.SENDERS] });
    }
  });

  const refreshSendersMutation = useMutation({
    mutationFn: () => refreshSenders(),
    onError: () => {
      ErrorNotification("A problem occurred while fetching senders' statuses from Mailjet.");
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [ReactQueryKeys.SENDERS] });
      SuccessNotification("Statuses from Mailjet updated successfully.");
    }
  });

  return {
    removeSenderMutation,
    switchLogModeSenderMutation,
    saveSenderMutation,
    refreshSendersMutation
  };
}
